<template>
  <DxPopup
    :visible="showPopupAlert"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-title="true"
    :width="popupWidth"
    :height="'auto'"
    :min-height="'250px'"
    :title="title || 'Gcorp'"
    @hidden="onHide"
    :ref="'gcPopupAlert'"
    :show-close-button="false"
  >
    <div class="gc-popup-alert-container">
      <div class="gc-popup-alert-content">
        <span v-html="message"></span>
      </div>
      <div class="gc-popup-alert-button-row">
        <DxButton
          text="OK"
          type="default"
          styling-mode="contained"
          @click="onHide"
        />
      </div>
    </div>
  </DxPopup>
</template>
<script>
import { DxPopup } from "devextreme-vue/popup";

export default {
  name: "GcPopupAlert",
  data() {
    return {
      show: this.showPopupAlert,
    };
  },
  props: {
    showPopupAlert: {
      type: Boolean,
    },
    title: {
      type: String,
      default: "",
    },
    isXSmall: {
      type: Boolean,
    },
    message: {
      type: String,
      default: "",
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    message(value) {
      // eslint-disable-next-line no-console
      // this.$logger.debug("Message watched:", value);
      this.$refs["gcPopupAlert"].instance.hide();
    },
  },
  components: {
    DxPopup,
  },
  methods: {
    onHide() {
      this.$emit("update:showPopupAlert", false);
      this.$emit("update:message", "");
    },
  },
  computed: {
    popupWidth() {
      return this.isXSmall ? "80vw" : "50vw";
    },
  },
};
</script>

<style lang="scss">
.gc-popup-alert-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}
.gc-popup-alert-content {
  flex-grow: 1;
}

.gc-popup-alert-button-row {
  position: absolute;
  bottom: 16px;
  height: 45px;
  width: 95%;
  display: flex;
  justify-content: flex-end;
}
</style>
